import { default as BaseModal } from "@ds-developer/modal";
import { Grid, Typography } from "@material-ui/core";
import Button from "@ds-developer/button";
import React from "react";

const UpdateDocumentConfirmationModal: React.FC<{
  onCloseClick: () => void;
}> = ({ onCloseClick }) => (
  <BaseModal
    open
    actions={
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} sm={6}>
          <Button
            color="default"
            onClick={onCloseClick}
            variant="outlined"
            data-test="close-button"
          >
            Close
          </Button>
        </Grid>
      </Grid>
    }
    title="Upload successful"
  >
    <Typography variant="body1">
      Your document has been successfully uploaded and sent to the team for
      review.
    </Typography>
    <Typography variant="body1">
      Please note working hours for reviews are 9am - 5pm, Monday to Friday.
    </Typography>
  </BaseModal>
);

export default UpdateDocumentConfirmationModal;
